// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wv1H","colBig":"styles_colBig__8ezL2","colSmall":"styles_colSmall__2tRsB"};